import React from "react";
import { Box, Typography } from "@mui/material";

interface StackedSelectionSummaryProps {
  stacks: number;
  segments: number;
  /** Shown when the selection can't produce a valid chart (no visible Stack). */
  warning?: string;
}

/**
 * Compact "N stacks × M segments = K cells" summary, with an optional
 * validation warning when the save gate (>=1 visible Stack) is unmet.
 */
const StackedSelectionSummary: React.FC<StackedSelectionSummaryProps> = ({
  stacks,
  segments,
  warning,
}) => {
  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 1,
        backgroundColor: warning ? "#fdecea" : "#f0f7ff",
        border: `1px solid ${warning ? "#f5c6cb" : "#cfe3fb"}`,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {stacks} {stacks === 1 ? "stack" : "stacks"} × {segments}{" "}
        {segments === 1 ? "segment" : "segments"} = {stacks * segments}{" "}
        {stacks * segments === 1 ? "cell" : "cells"}
      </Typography>
      {warning && (
        <Typography
          variant="caption"
          sx={{ color: "#b71c1c", display: "block", mt: 0.5 }}
        >
          {warning}
        </Typography>
      )}
    </Box>
  );
};

export default StackedSelectionSummary;
